import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import bgTranslation from './locales/bg/translation.json';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import ruTranslation from './locales/ru/translation.json';
import bgHomepage from './locales/bg/homepage.json';
import enHomepage from './locales/en/homepage.json';
import deHomepage from './locales/de/homepage.json';
import ruHomepage from './locales/ru/homepage.json';
import bgContact from './locales/bg/contact.json';
import enContact from './locales/en/contact.json';
import deContact from './locales/de/contact.json';
import ruContact from './locales/ru/contact.json';
import bgAbout from './locales/bg/about.json';
import enAbout from './locales/en/about.json';
import deAbout from './locales/de/about.json';
import ruAbout from './locales/ru/about.json';
import bgPortfolio from './locales/bg/portfolio.json';
import enPortfolio from './locales/en/portfolio.json';
import dePortfolio from './locales/de/portfolio.json';
import ruPortfolio from './locales/ru/portfolio.json';
import bgTerms from './locales/bg/terms.json';
import enTerms from './locales/en/terms.json';
import deTerms from './locales/de/terms.json';
import ruTerms from './locales/ru/terms.json';

const resources = {
  bg: {
    translation: bgTranslation,
    homepage: bgHomepage,
    contact: bgContact,
    about: bgAbout,
    portfolio: bgPortfolio,
    terms: bgTerms
  },
  en: {
    translation: enTranslation,
    homepage: enHomepage,
    contact: enContact,
    about: enAbout,
    portfolio: enPortfolio,
    terms: enTerms
  },
  de: {
    translation: deTranslation,
    homepage: deHomepage,
    contact: deContact,
    about: deAbout,
    portfolio: dePortfolio,
    terms: deTerms
  },
  ru: {
    translation: ruTranslation,
    homepage: ruHomepage,
    contact: ruContact,
    about: ruAbout,
    portfolio: ruPortfolio,
    terms: ruTerms
  }
};

// Get saved language or default to Bulgarian
const savedLanguage = localStorage.getItem('i18nextLng');
const defaultLanguage = (savedLanguage && (savedLanguage === 'bg' || savedLanguage === 'en' || savedLanguage === 'de' || savedLanguage === 'ru')) ? savedLanguage : 'bg';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'bg',
    
    ns: ['translation', 'homepage', 'contact', 'about', 'portfolio', 'terms'],
    defaultNS: 'translation',
    
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      checkWhitelist: true,
    },
    
    whitelist: ['bg', 'en', 'de', 'ru'],
    
    interpolation: {
      escapeValue: false
    }
  });

// Ensure the detected/default language is saved to localStorage
if (!savedLanguage || (savedLanguage !== 'bg' && savedLanguage !== 'en' && savedLanguage !== 'de' && savedLanguage !== 'ru')) {
  localStorage.setItem('i18nextLng', defaultLanguage);
}

export default i18n; 